import { Button, Typography } from 'seagull';
import { DropdownMenu } from 'seagull/components/DropdownMenu';
import { AgreementsLiner18, MailSentLiner24, TrashLine, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
import pluralize from "../../utils/pluralize";
import styles from "./DraftsDashboard.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BulkActions = _ref => {
  let {
    numSelected,
    setBulkActionsOpen,
    bulkActionsOpen,
    bulkSend,
    bulkExternallySign,
    bulkDiscard
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [numSelected > 0 && /*#__PURE__*/_jsx(Typography, {
      testId: "drafts-dashboard-bulk-counter",
      children: "".concat(numSelected, " ").concat(pluralize('draft', numSelected), " selected")
    }), /*#__PURE__*/_jsx(DropdownMenu, {
      onOpenChange: setBulkActionsOpen,
      target: /*#__PURE__*/_jsx(Button, {
        testId: "drafts-dashboard-bulk-actions",
        skin: "primaryOutline",
        suffixIcon: bulkActionsOpen ? /*#__PURE__*/_jsx(WideArrowUpward, {}) : /*#__PURE__*/_jsx(WideArrowDownward, {}),
        disabled: numSelected === 0,
        children: "Bulk actions"
      }),
      children: [{
        icon: /*#__PURE__*/_jsx(MailSentLiner24, {
          size: 20
        }),
        testId: 'drafts-dashboard-bulk-send',
        text: 'Send proposals',
        onClick: bulkSend
      }, {
        icon: /*#__PURE__*/_jsx(AgreementsLiner18, {
          size: 20
        }),
        testId: 'drafts-dashboard-bulk-externally-sign',
        text: 'Approve on behalf of the client',
        onClick: bulkExternallySign
      }, {
        icon: /*#__PURE__*/_jsx(TrashLine, {}),
        testId: 'drafts-dashboard-bulk-remove',
        text: 'Discard drafts',
        intent: Intent.DiscardDraft,
        skin: 'error',
        onClick: bulkDiscard
      }].map(_ref2 => {
        let {
          icon,
          testId,
          text,
          intent,
          skin,
          onClick
        } = _ref2;
        return /*#__PURE__*/_jsx(DropdownMenu.Item, {
          iconStart: /*#__PURE__*/_jsx("div", {
            className: styles.bulkActionIcon,
            children: icon
          }),
          testId: testId,
          intent: intent,
          skin: skin,
          onClick: onClick,
          children: text
        }, testId);
      })
    })]
  });
};
export default BulkActions;